// extracted by mini-css-extract-plugin
export default {"filterContainer":"_3FqF0Rny","filterTitle":"wR2fmnDl","toggleSwitch":"rBO34suq","toggleSwitchOn":"IXyE74R5","toggleSwitchContainer":"_2KtjiDJT"};